<template>
  <div v-if="pdfdata">
    <template v-for="i in numPages">
      <template v-if="loaded.indexOf(i) >= 0 || (i >= currentPage - Number(offscreenPages) && i <= currentPage + Number(offscreenPages))">
        <pdfvuer class="page" 
                 :resize="true" 
                 :src="pdfdata" 
                 :page="i" 
                 :key="i" 
                 :id="i" 
                 :ref="'ref' + i">
        </pdfvuer>
      </template>
      <template v-else>
        <div :style="pageStyle" 
             :key="i" 
             :id="i">
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped>
</style>
 
<script>
import pdfvuer from "pdfvuer";

export default {
  components: {
    pdfvuer,
  },
  props: {
    options: Object,
    offscreenPages: String
  },
  data: function() {
    return {
      pdfdata: undefined,
      error: false,
      currentPage: 1,
      loaded: [],
      numPages: 0,
      pageHeight: 0,
    };
  },
  computed: {
    pageStyle: function() {
      if (this.pageHeight === 0) {
        return "";
      }
      return "height: " + this.pageHeight + "px";
    }
  },
  created() {
    let self = this;
    self.pdfdata = pdfvuer.createLoadingTask(self.options);

    self.pdfdata.then(pdf => {
      self.$store.state.pdfLoading = false;
      self.$store.state.pdfDataLoad = true;
      self.numPages = pdf.numPages;
      self.$emit("pageChanged", {
        currentPage: 1,
        numPages: self.numPages
      });

      for (let i = self.currentPage; i <= self.currentPage + Number(self.offscreenPages); i++) {
        self.loaded.push(i);
      }

      window.addEventListener("scroll", function() {
        if(self.pdfdata) {
          changePage();
        }
      }, true);
      
      self.$store.state.openTime = Math.floor(Date.now() / 1000);
      
      function changePage() {
        //let yOffset = window.pageYOffset;
        let yOffset = document.getElementsByClassName('content-container')[0].scrollTop;
        let previousPage = self.currentPage;
        let i = 1;
        
        do {
          if(document.getElementById(i) && document.getElementById(i+1)) {
            if (yOffset >= document.getElementById(i).offsetTop && yOffset <= document.getElementById(i + 1).offsetTop) {
              self.currentPage = i;
            }
          }
        } while (++i < self.numPages);
        

        if(document.getElementById(i)) {
          if (yOffset >= document.getElementById(i).offsetTop) {
            self.currentPage = i;
          }
        }

        if (self.currentPage != previousPage) {
          self.$emit("pageChanged", {
            currentPage: self.currentPage,
            numPages: self.numPages
          });
        }

        for (let j = self.currentPage - Number(self.offscreenPages); j <= self.currentPage + Number(self.offscreenPages); j++) {
          if (self.loaded.indexOf(j) < 0) {
            self.loaded.push(j);
            //console.log(self.loaded);
          }
        }

        if (self.pageHeight == 0) {
          self.pageHeight = document.getElementById(self.currentPage).offsetHeight;
        }
      }
    }).catch(err => {
      self.$store.state.pdfLoading = false;
      self.$store.state.pdfError = true;
    });
  },
  beforeDestroy: function() {
    if (this.pdfdata) {
      this.pdfdata.destroy();
    }
    this.pdfdata = null;
  },
}
</script>


// WEBPACK FOOTER //
// LazyPdfVuer.vue?07418d18